/* istanbul ignore file
TODO: Remove ignore and add tests as part off DMD-4866 */
import { z } from 'zod';

import { BrandFontTypes } from 'reservations/brand/constants/enums';
import { defaultWhenNullish } from 'utility/zod';

const BrandFontSource = z.object({
  id: z.string().or(z.number()),
  url: z.string(),
  format: z.string(),
  file: z.string().or(z.number())
});
type BrandFontSource = z.infer<typeof BrandFontSource>;

const BrandFontVariant = z.object({
  id: z.string().or(z.number()).optional(),
  name: z.string(),
  style: z.string().nullish(),
  weight: z.number().nullish(),
  displayName: z.string()
});
type BrandFontVariant = z.infer<typeof BrandFontVariant>;

const BrandFont = z.object({
  id: z.string().or(z.number()).optional(),
  name: z.string(),
  slug: z.string(),
  sources: defaultWhenNullish(z.array(BrandFontSource), []),
  variants: defaultWhenNullish(z.array(BrandFontVariant), []),
  isDefault: defaultWhenNullish(z.boolean(), false),
  fontType: z.enum([BrandFontTypes.CUSTOM, BrandFontTypes.GOOGLE])
});
export type BrandFont = z.infer<typeof BrandFont>;

// BrandStyle can have several layers of nested structure whose values can be one of the following
// number, string or another dictionary/record
const BrandStyle = z.record(z.string(), z.any());
export type BrandStyle = z.infer<typeof BrandStyle>;

const BrandStyles = z.object({
  base: defaultWhenNullish(z.record(z.string(), z.any()), {}),
  styles: defaultWhenNullish(z.array(BrandStyle), [])
});
export type BrandStyles = z.infer<typeof BrandStyles>;

const PrivateBrandStyles = z.object({
  base: defaultWhenNullish(z.record(z.string(), z.any()), {}),
  styles: defaultWhenNullish(z.record(z.string(), BrandStyle), {})
});
export type PrivateBrandStyles = z.infer<typeof PrivateBrandStyles>;

export const BrandLogo = z.object({
  id: z.string().or(z.number()),
  alt_text: defaultWhenNullish(z.string(), ''),
  url: defaultWhenNullish(z.string(), '')
});

export type BrandLogo = z.infer<typeof BrandLogo>;

export const Brand = z.object({
  fonts: defaultWhenNullish(z.array(BrandFont), []),
  logos: defaultWhenNullish(z.array(BrandLogo), []),
  styles: defaultWhenNullish(PrivateBrandStyles, { base: {}, styles: {} })
});

export type Brand = z.infer<typeof Brand>;

export const BrandImage = z.object({
  url: defaultWhenNullish(z.string(), ''),
  alt_text: defaultWhenNullish(z.string(), ''),
  image_large_url: defaultWhenNullish(z.string(), '')
});

export type BrandImage = z.infer<typeof BrandImage>;
